import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchContentForPage } from "../../store/content/operations";
import { isPageLoading, getPage } from "../../store/content/selectors";
import { Icon } from "@blueprintjs/core";

import CustomIcon from "../../components/CustomIcon"; 

class IconFromPath extends Component {  

  componentDidMount() {
    this.props.fetchContentForPage();
  }

  getIconFromPath = (obj, path) =>
    path.split(".").reduce((acc, part) => {
      if (!acc) {
        return undefined;
      }
      const val = acc[part];
      return acc && val;
    }, obj);

  render() {
    return (
      <span>
        {!this.props.custom && <Icon icon={this.getIconFromPath(this.props.pageContent, this.props.innerPath)} className={this.props.className} iconSize={this.props.iconSize} />}
        {this.props.custom && <CustomIcon name={this.getIconFromPath(this.props.pageContent, this.props.innerPath)} className={this.props.className} size={this.props.iconSize} />}
      </span>
    );
  }
}

IconFromPath.propTypes = {
  /* path should exclude the language suffix for the attribute. it should only contain the page.attribute.subattribute
   like home.content_blocks.why_co_own.title or home.meta_title**/
  path: PropTypes.string,
  custom: PropTypes.bool
};

const mapStateToProps = (state, props) => {
  const pageSlug = props.path.split(".")[0];
  const ownProps = { ...props, pageSlug: pageSlug };
  return {
    pageSlug: pageSlug,
    innerPath: ownProps.path.substring(ownProps.path.indexOf(".") + 1),
    locale: state.i18n.locale,
    pageContent: getPage(state, ownProps),
    loading: isPageLoading(state, ownProps)
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  const pageSlug = ownProps.path.split(".")[0];
  return {
    fetchContentForPage: () => dispatch(fetchContentForPage(pageSlug))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconFromPath);
